module.exports = __webpack_public_path__ + "img/PL09011.7533820b.png";